import LcView from "lib/shared/view";
import quizQuestionsChannel from "../../../../channels/quiz_questions_channel";

export default LcView.create({
  ready() {
    $("body").on("submit", "form#prototype-form", function () {
      $.ajax({
        beforeSend() {
          $("#result-indicator").html("Submitted. Please wait.");
          $("#response-area").html("");
          $("#prompt-area").html("");
          $("#guide-portion-sent").html("");
        },
        data: $(this).serialize(),
        dataType: "json",
        error(data, status, _settings) {
          if (status === "timeout") {
            $("#result-indicator").html("Timed out.");
          } else {
            $("#result-indicator").html(data.responseText);
          }
        },
        success(data, _status, _settings) {
          const finalPrompt = data.final_prompt;
          const guidePortionSent = data.guide_portion_sent;

          $("#prompt-area").text(finalPrompt);
          $("#guide-portion-sent").text(guidePortionSent);
        },
        type: "POST",
        url: $(this).attr("action")
      });
      return false;
    });

    $("#quiz_focus").change(function () {
      const summarySectionOptions = $("#summary_section");
      summarySectionOptions.empty();

      if ($(this).val() === "Summary & Analysis") {
        $.ajax({
          data: { focus: $(this).val(), resource_id: $("#resource").val() },
          dataType: "json",
          error(data) {
            $("#result-indicator").html(data.responseText);
          },
          success(data) {
            data.summary_sections.forEach((summarySection) => {
              const option = document.createElement("option");
              [option.innerText, option.value] = summarySection;
              summarySectionOptions.append(option);
            });
          },
          type: "GET",
          url: $(this).data("summarySectionsPath")
        });
      }
    });
    quizQuestionsChannel();
  }
});
